export default "__VITE_ASSET__CgfkT6au__"